"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHtml = void 0;
const node_fetch_1 = __importDefault(require("node-fetch"));
const iconv_lite_1 = __importDefault(require("iconv-lite"));
const getHtml = (url, encoding = "utf-8") => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield node_fetch_1.default(url, {
            headers: {
                "User-Agent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/51.0.2704.106 Safari/537.36 OPR/38.0.2220.41",
            },
        });
        if (!response.ok) {
            const err = new Error(response.statusText);
            console.error("Failed @ `getHtml`:", err);
            throw err;
        }
        const dataBuffer = yield response.buffer();
        const parsedHtml = iconv_lite_1.default.decode(dataBuffer, encoding);
        return parsedHtml;
    }
    catch (err) {
        console.error("Error! Failed to `getHtml`: ", err);
        throw err;
    }
});
exports.getHtml = getHtml;
//# sourceMappingURL=getHtml.js.map